import { useCallback } from 'react'

import { Form } from '@ana/shared'
import useOnMount from 'hooks/useOnMount'
import qs from 'querystring'
import CodeScreen from 'screens/Code'

import AxiosErrorSummary from '../@types/AxiosErrorSummary'
import ServerError from '../@types/ServerError'
import { useSetAnswers } from '../providers/AnswersProvider'
import { usePatient } from '../providers/PatientProvider'

const hasCodeOnSearchParams = () => {
  const searchParamsWithoutQuestionMark = window.location.search.substr(1)
  const codeFromSearchParams = qs.parse(searchParamsWithoutQuestionMark)?.code

  return typeof codeFromSearchParams === 'string'
}

const CodePage: React.FC = () => {
  const setAnswers = useSetAnswers()
  const patient = usePatient()

  const error = patient?.error as AxiosErrorSummary<ServerError> | undefined

  const handleSubmit = useCallback(
    (code: string) => {
      setAnswers((previous: Partial<Form>) => ({ ...previous, code }))
    },
    [setAnswers]
  )

  useOnMount(() => {
    if (!error && hasCodeOnSearchParams()) return
  })

  return <CodeScreen error={error} onSubmit={handleSubmit} />
}

export default CodePage
